import iconEvent from 'assets/images/eventBunpimay/iconTextEvent.png'
import iconTop1 from 'assets/images/eventBunpimay/iconTop1Prize.png'
import iconTop2 from 'assets/images/eventBunpimay/iconTop2Prize.png'
import iconTop3 from 'assets/images/eventBunpimay/iconTop3Prize.png'
import iconPhone from 'assets/images/eventBunpimay/samsung.png'
import iconHeadphone from 'assets/images/eventBunpimay/headphonePrize.png'
import iconMoney from 'assets/images/eventBunpimay/moneyPrize.png'
import iconTopRight from 'assets/images/eventBunpimay/iconTopRight.png'
import iconTopLeft from 'assets/images/eventBunpimay/iconTopLeft.png'

function EventBunpimayPrize() {
	const listPrize = [
		{
			id: 1,
			iconTop: iconTop1,
			iconPrize: iconPhone,
			namePrize: "Smart phone Samsung Galaxy A05"
		},
		{
			id: 2,
			iconTop: iconTop2,
			iconPrize: iconHeadphone,
			namePrize: "Huawei FreeBuds 5i"
		},
		{
			id: 3,
			iconTop: iconTop3,
			iconPrize: iconMoney,
			namePrize: "500.000 Kip Umoney"
		},
	]
	return (
		<div className="box-prize">
			<div className="box-prize-description">
				<img
					draggable="false"
					className="icon-event"
					srcSet={`${iconEvent} 2x`}
				/>
			</div>
			<div className="box-prize-list">
				<img draggable="false" className='icon-top-right' src={iconTopRight} />
				<img draggable="false" className='icon-top-left' src={iconTopLeft} />
				{listPrize.map(item =>
					<div className='box-prize-list-item' key={`item-prize-${item.id}`} >
						<img draggable="false" className='icon-top' src={item.iconTop} />
						<img draggable="false" className='icon-prize' src={item.iconPrize} />
						<span className='name-prize'>{item.namePrize}</span>
					</div>
				)}
			</div>
		</div>
	)
}

export default EventBunpimayPrize
